// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__R-bgc","headLogo":"Logo_headLogo__2VMnX"};